export default [
  {
    path: '/product-movements',
    name: 'product-movement',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product-movement/index.vue')
  }
]
